import React, { useState } from 'react';
import styled from 'styled-components';
import ContactLine from './ContactLine/ContactLine';

const FooterComponent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  background: white;
  padding-bottom: 60px;
  @media (max-width: 1024px) {
    padding-bottom: 60px;
  }
  @media (max-width: 669px) {
    padding-top: 0;
    padding-bottom: 0;
  }
`;

const dataLine = [
    {
        title: 'Telegram',
        targetContact: 't.me/laomining',
        href: 'https://t.me/laomining',
    },
    {
        title: 'E-mail',
        targetContact: 'ez@laohe.io',
        href: 'mailto:ez@laohe.io',
    },
    {
        title: 'Phone',
        targetContact: '+86 133 9216 4295',
        href: 'tel:+8613392164295',
    },
    {
        title: 'Address',
        targetContact: 'Shenzhen, Gangwan 3rd Blvd, bldg A, 123',
        href: 'https://maps.app.goo.gl/cSMi951FFszkRU8h9',
    },
];

const Footer: React.FC = () => {
    const [isLine, setIsLine] = useState(false);
    return (
        <FooterComponent id="feedback">
            {dataLine.map(contacts => (
                <ContactLine
                    data={contacts}
                    isLine={isLine}
                    setIsLine={setIsLine}
                    key={contacts.title}
                />
            ))}
        </FooterComponent>
    );
};

export default Footer; 